import gql from 'graphql-tag';

const defaultsFragment = gql`
  fragment AMDefaults on HEAccount {
    activeMatchSubscriptionDefaults {
      id
      institution
      version
      academicThresholds {
        gpa
        act
        sat
      }
    }
  }
`;

const subscriptionsFragment = gql`
  fragment AMSubscriptions on HEAccount {
    activeMatchSubscriptions {
      edges {
        node {
          id
          version
          institution
          type
          majors
          connection
          academicThreshold {
            enabled
            thresholds {
              sat
              gpa
              act
            }
          }
          startDate
          endDate
          visible
          audience {
            diversity
            zipCode {
              zipCode
              radius
            }
            state
            county {
              state
              county
            }
            sector
          }
          competitors {
            scid
            name
          }
        }
      }
    }
  }
`;

export const configureThresholdsQuery = gql`
  query AMSubscriptions {
    viewer {
      id
      heAccount {
        id
        ...AMDefaults
        ...AMSubscriptions
      }
    }
  }
  ${defaultsFragment}
  ${subscriptionsFragment}
`;

export const competitorsMessagingQuery = gql`
  query AMCompetitorsMessages {
    viewer {
      id
      heAccount {
        id
        activeMatchMessages {
          id
          version
          competitors {
            name
            scid
            collegeCore {
              address {
                city
                state
              }
            }
            messageOption
            defaultMessage
            messages {
              audience {
                diversity
                zipCode {
                  zipCode
                  radius
                }
                state
                county {
                  state
                  county
                }
                sector
              }
              message
            }
          }
        }
      }
    }
  }
`;

export const majorsMessagingQuery = gql`
  query AMMajorsMessages {
    viewer {
      id
      heAccount {
        id
        scid
        activeMatchMessages {
          id
          version
          majors {
            enabled
            categoryId
            category
            messageOption
            defaultMessage
            messages {
              majorId
              major
              message
            }
          }
        }
      }
    }
  }
`;
